<template>
  <div class="shop-cart-list-entry">
    <div class="shop-cart-list__column">
      <div
        v-if="isEditable"
        class="shop-cart-list-entry__remove"
      >
        <AppIcon
          v-if="clientStore.isDesktop"
          icon="deselect"
          :is-raw="true"
          @click="clearProduct(data.product)"
        />
        <AppIcon
          v-else
          icon="trash-bin"
          :is-raw="true"
          @click="clearProduct(data.product)"
        />
      </div>

      <div class="shop-cart-list-entry__product">
        <div class="list-entry-product__image">
          <AtomImage
            v-if="data.product?.image"
            :src="data.product.image"
            behaviour="contain"
            :disable-lazy="true"
          />
          <AppIcon
            v-else
            icon="product-placeholder"
            :is-raw="true"
          />
        </div>

        <div class="list-entry-product__information">
          <ShopProductCardPrice />

          <SlotLink :url="`../produkte/${data.product?.slug}`">
            <div class="list-entry-product__name">
              {{ data.product.title }}
            </div>
          </SlotLink>
        </div>
      </div>
    </div>

    <div class="shop-cart-list__column">
      <div class="shop-cart-list__subcolumn">
        <AtomClickAndCollectNotice
          :force-info="true"
          :has-outlines="true"
          :force-click-and-collect="hasClickAndCollect && !isEditable"
        />

        <ShopOrderItemAmount
          :quantity="data.quantity"
          @count-up="cartStore.addProduct(data.product, {
            openPopup: false,
            isAdd: true,
          })"
          @count-down="cartStore.addProduct(data.product, {
            openPopup: false,
            isAdd: false,
          })"
        />
      </div>

      <div class="shop-cart-list__summary">
        {{ currency }}
        {{ entrySummary?.toFixed(2) }}
        <span class="shop-cart-list__summary-mwst">
          {{ useTranslation('general', 'inclusive_mwst') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
    data: {
        type: Object,
        default: () => {},
    },
});

const isEditable = inject('is-editable');
provide('item', props.data.product);
provide('product', props.data.product);

/*
  Cart store
*/
const cartStore = useCartStore();
const clearProduct = () => {
    cartStore.removeProduct(props.data.product);
};

const hasClickAndCollect = computed(() => cartStore.hasClickAndCollect);

const entrySummary = computed(
    () => cartStore.getEntrySummary(props.data.product),
);

const currency = computed(() => cartStore.getCurrency);

/* Client Store */
const clientStore = useClientDeviceStore();
</script>

<style lang="scss" scoped>
.shop-cart-list-entry {
    @include grid-layout(2);

    position: relative;
    display: grid;
    padding: 20px 0;
    border-top: 2px solid $C_GREY_LIGHT;
    color: $C_GREEN_DARK;
    column-gap: 20px;

    @include tablet {
        @include grid-layout(1);
        row-gap: 15px;
    }

    &:last-child {
        border-bottom: 2px solid $C_GREY_LIGHT;
    }
}

.shop-cart-list-entry__remove {
    display: flex;
    min-width: 45px;
    min-height: 100%;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    @include tablet {
        position: absolute;
        top: 10px;
        right: 5px;
        min-width: unset;
        height: auto;
        min-height: unset;

        .app-icon {
            width: 28px;
        }
    }

    .app-icon {
        width: 18px;
    }
}

.shop-cart-list-entry__product {
    display: flex;
}

.list-entry-product__image {
    @include fluid('min-width', 60px, 80px);
    @include fluid('height', 60px, 80px);

    overflow: hidden;
    padding: 12px;
    border: 2px solid $C_GREEN_DARK;
    border-radius: 12px;
    background: $C_WHITE;
}

.shop-cart-list__column {
    display: flex;

    @include tablet {
        align-items: center;

        &:last-child {
            display: flex;
            row-gap: 15px;
        }
    }

    @include mobile {
        flex-wrap: wrap;
    }
}
.list-entry-product__information {
    @include fluid('max-width', 0px, 600px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 20px;
    row-gap: 5px;

    @include tablet {
        max-width: unset;
        justify-content: flex-start;
        margin-top: 5px;
    }
}

.list-entry-product__name {
    @include typo-size('label');
    @include typo-font('regular');
    word-break: break-word;

    @include tablet {
        padding-right: 62px;
    }
}

.shop-cart-list__summary {
    @include typo-size('label');
    @include typo-font('regular');
    margin-top: auto;
    margin-bottom: auto;
    margin-left: auto;
    color: $C_GREEN_DARK;

    @include tablet  {
        width: 50%;
        order: 3;
        margin-top: unset;
        margin-bottom: unset;
        text-align: right;
    }
}

.shop-cart-list__summary-mwst {
    @include typo-size('nav');
    display: block;
}

.shop-cart-list__subcolumn {
    display: flex;
    width: 100%;
    justify-content: space-between;

    @include mobile {
        width: 100%;
    }
}
</style>
